// TanStack Query cache keys for admin/payments.
export const adminPaymentKeys = {
  all: ["admin", "payments"] as const,
  pending: (limit: number, offset: number, q: string) =>
    ["admin", "payments", "pending", limit, offset, q] as const,
  // Plans available for manual release (re-uses /api/v2/admin/plans).
  applicablePlans: () => ["admin", "payments", "applicable-plans"] as const,
};
